<template>
    <div class="d-block" style="width:100%;">
        {{ getDropdowns(qid) }}
        <div class="col-lg-12 mb-2" v-if="dropdowns && dropdowns.length > 0">
            <select class="form-control" v-on:change="updateAnswer($event.target.value)">
                <option value="">Select an option</option>
                <option v-for="dropdown in dropdowns" v-bind:value="dropdown.dropdown">{{ dropdown.dropdown }}</option>
            </select>
        </div>
        <div class="col-lg-12 mb-2">
            <textarea
                        v-bind:placeholder="placeholder"
                        v-model="fieldValue"
                        @input="$emit('input', fieldValue)"
                        class="form-control"></textarea>
        </div>
    </div>
</template>





<script>

    export default {
        props: [
            'value',
            'qid'
        ],
        data() {
            return {
                fieldValue: this.value,
                dropdowns: [],
                placeholder: 'Enter answer here'
            }
        },
        watch: {
          value(newValue) {
              this.fieldValue = newValue;
          }
        },
        methods: {
            updateAnswer(newValue) {
                if (this.fieldValue === null) {
                    this.fieldValue = newValue;
                } else if(newValue.length > 0) {
                    this.fieldValue = this.fieldValue + ' ' + newValue;
                }
                console.log('Field value', this.fieldValue);
                this.$emit('input', this.fieldValue);
            },
            getContainerClasses(field) {
                return this.$parent.getContainerClasses(field);
            },
            getDropdowns(questionId) {
                var vm = this;
                this.getDb(function onConnectedGetDropdowns(db) {
                    var dropdownsStore = db.transaction('dropdowns').objectStore('dropdowns');
                    if (dropdownsStore) {
                        var questionResults = dropdownsStore.index('question_id').getAll(questionId);
                        questionResults.onsuccess = function(e) {
                            vm.dropdowns = e.target.result;
                            if(vm.dropdowns && vm.dropdowns.length > 0) {
                                vm.placeholder = 'Select options from dropdown above or enter your answer manually';
                            }
                            return e.target.result;
                        }
                        questionResults.onerror = function(e) {
                            console.log('Problem', e);
                        }
                    }
                })
            },
        },
    }
</script>